var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coach-review-list"},[(_vm.rating == 0)?[_c('span',{staticClass:"no-data"},[_vm._v(_vm._s('まだレビューがありません'))])]:[_c('rating-star',{attrs:{"rating":_vm.rating}}),_c('span',[_vm._v(_vm._s(_vm.numberFormat(_vm.reviewCount)))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }